<template>
  <a-form-item
    :label="data.fieldname"
    class="date-graoup"
  >
    <a-checkbox
      v-if="data.fieldkey === 'next_followup_time'"
      :checked="isDelay === 1 ? true : false"
      @change="handleCheckboxNextFollowupTime"
    >
      {{ $t('message["103"]') }}
    </a-checkbox>
    <a-checkbox-group
      v-if="data.fieldkey === 'followup_remind_time' && data.checkboxOptions"
      :value="period"
      :options="data.checkboxOptions"
      class="followup_remind_time-checkbox"
      @change="onChangeFollowupRemindTime"
    />
    <!-- 如果列表视图设置 -->
    <a-select
      v-if="data.filtertype === 'listview' && data.options && data.options.length"
      :value="dynamic"
      class="block"
      :class="{ 'm-b-16': dynamic === 'range' }"
      :placeholder="$t('message[855]')"
      :allow-clear="true"
      @change="handleChangeTimeType"
    >
      <a-select-option
        v-for="item in data.options"
        :key="item.id"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
    <a-range-picker
      v-if="(data.filtertype === 'listview' && dynamic === 'range') || data.filtertype !== 'listview'"
      :placeholder="dateTimePlace"
      :value="rangeTime"
      :disabled="data.disabled"
      class="block"
      @change="onChange"
    />
    <!-- <a-range-picker
      v-if="!starttime || !endtime"
      :placeholder="dateTimePlace"
      :disabled="data.disabled"
      @change="onChange"
    /> -->
  </a-form-item>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    data: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      dateFormat: 'YYYY-MM-DD',
      rangeTime: [],
      starttime: '',
      endtime: '',
      dynamic: undefined,
      isDelay: 0,
      period: []
    }
  },
  computed: {
    dateTimePlace () {
      return this.$t('message["561"]').split('|')
    }
  },
  watch: {
    data: {
      handler (val) {
        this.setDefault(val)
      },
      immediate: true
    }
  },
  methods: {
    moment,
    setDefault (val) {
      const { fieldvalue = {} } = val

      this.starttime = fieldvalue.starttime || ''
      this.endtime = fieldvalue.endtime || ''
      this.dynamic = fieldvalue.dynamic || undefined
      if (this.starttime && this.endtime) {
        this.rangeTime = [this.$moment(this.starttime, 'YYYY-MM-DD HH:mm'), this.$moment(this.endtime, 'YYYY-MM-DD HH:mm')]
      }

      if (val.fieldkey === 'next_followup_time') {
        val.checkboxOptions = [{
          id: val.fieldconfig.fieldkey,
          name: this.$t('message["103"]')
        }]
        this.isDelay = fieldvalue.is_dely || 0
      }

      if (val.fieldkey === 'followup_remind_time') {
        val.checkboxOptions = val.options.map(item => {
          return {
            label: item.name,
            value: item.id
          }
        })
        this.period = fieldvalue.period || []
      }
    },
    onChange (date, dateString) {
      this.rangeTime = date
      this.starttime = dateString[0]
      this.endtime = dateString[1]

      let obj = this.setObj()
      this.$emit('change', obj)
    },
    setObj () {
      let obj = {
        starttime: this.starttime,
        endtime: this.endtime
      }
      if (this.data && this.data.fieldkey === 'next_followup_time' && this.data.fieldconfig && this.data.fieldconfig.fieldkey) {
        obj[this.data.fieldconfig.fieldkey] = this.isDelay
      }
      if (this.data && this.data.fieldkey === 'followup_remind_time') {
        obj.period = this.period
      }
      if (this.data.filtertype === 'listview') {
        obj.dynamic = this.dynamic
      }
      return obj
    },
    handleCheckboxNextFollowupTime (e) {
      // console.log(`checked = ${e.target.checked}`)
      const checked = e.target.checked
      this.isDelay = checked ? 1 : 0

      let obj = this.setObj()
      this.$emit('change', obj)
    },
    onChangeFollowupRemindTime (val) {
      this.period = val
      let obj = this.setObj()
      this.$emit('change', obj)
    },
    handleChangeTimeType (val) {
      this.dynamic = val
      if (val !== 'range') {
        this.starttime = ''
        this.endtime = ''
      }

      let obj = this.setObj()
      this.$emit('change', obj)
    }
  }
}
</script>

<style lang="scss" scoped>
.followup_remind_time-checkbox {
  display: block;
}
.ant-select.block,  .ant-calendar-picker.block {
  display: block;
}
</style>
